
const agendaDeatils = [
	{
		id: 1,
		time:"2.00 pm - 4.00 pm",
		detail:`<div><strong>Winpe Collegium</strong> <br /> Privilege Members only, closed door sessions on the Diversity Agenda</div>`,
		speaker:`<div></div>`,
	},
]
const agendaDeatils1 = [
	{
		id: 4,
		time:"3.30 pm - 4.00 pm",
		detail:`<div><i> Registration and High Tea </i></div>`,
		speaker:`<div></div>`,
	},
	{
		id: 5,
		time:"4.00 pm - 4.10 pm",
		detail:"Welcoming of Guests and Lighting of Lamps",
		speaker:`<div></div>`,
	},
	{
		id: 6,
		time:"4.10 pm - 4.20 pm ",
		detail:"Introduction to Winpe",
		speaker:`<div>Ms. Nupur Garg</div>`,
	},
	{
		id: 7,
		time:"4.20 pm - 4.30 pm",
		detail:"Opening Address",
		speaker:`<div>Ms. Renuka Ramnath</div>`,
	},
	{
		id: 8,
		time:"4.30 pm - 4.35 pm",
		detail:"Message for Winpe",
		speaker:`<div>Ms. Anita George</div>`,
	},
	{
		id: 9,
		time:"4.35 pm - 5.10 pm",
		detail:`<div>Panel Discussion: <br />Diversity 
		- Perspectives from PE firms <br />
		- Why is diversity more than a buzz word? <br />
		- Why have PE firms fallen short on diversity statistics? What are the challenges that exist? <br />
		- What is driving the need to change status quo? What is the opportunity and way forward?</div>`,
		speaker:`<div><strong>Moderator</strong> : Shrija Agarwal, HT Mint <br /><br />
		Abhay Pandey, A91 Partners <br />
		Mukund Krishnaswami, Lighthouse Advisors <br />
		Roshini Bakshi, Everstone Capital<br />
		Sandeep Naik, General Atlantic <br />
		Sanjeev Krishan, PwC</div>`,
	},
	{
		id: 10,
		time:"5.10 pm - 5.40 pm",
		detail:`<div>Winpe: Why and What</div>`,
		speaker:`<div><strong>Moderator</strong> : Nisha Poddar, CNBC <br /><br />
		Renuka Ramnath, Multiples <br />
		Sujoy Bose, NIIF <br />
		Zia Mody, AZB <br />
		Nupur Garg, Winpe</div>`,
	},
	{
		id: 11,
		time:"5.40 pm - 5.50 pm",
		detail:"An entrepreneur's journey, with a female lens",
		speaker:`<div> Ms. Ameera Shah</div>`,
	},
	{
		id: 12,
		time:"5.50 pm - 6.00 pm",
		detail:"Closing note",
		speaker:`<div> Ms. Zia Mody</div>`,
	},
	{
		id: 13,
		time:"6.00 pm onwards",
		detail:`<div><i> Cocktails and Hors d'oeuvres </i></div>`,
		speaker:`<div></div>`,
	},
]
const agendaDeatils2 = [
	{
		id: 4,
		time:"2.30 pm - 2.45 pm",
		detail:`<div>Welcome note and context setting</div>`,
		speaker:`<div>Nupur Garg, LP Advisor and IC member</div>`,
	},
	{
		id: 5,
		time:"2.45 pm - 3.00 pm",
		detail:"The changing landscape of investing",
		speaker:`<div>Nithya Easwaran, Multiples Alternate Asset Management</div>`,
	},
	{
		id: 6,
		time:"3.00 pm - 4.00 pm",
		detail:"Career tracks in investing: panel discussion followed by Q&A",
		speaker:`<div>Anjana Sasidharan, Investment Professional <br />
						Harjot Dhaliwal, Apax Partners <br />
						Rochelle D'Souza, Lighthouse Advisors <br />
						Simrun Mehta, KKR Advisors
			</div>`,
	},
]

export default { agendaDeatils, agendaDeatils1, agendaDeatils2 }



// WEBPACK FOOTER //
// ./src/constant/agendaDetails.js